import axios from "axios";
import { loginRequest } from "../API/authApi";

const KEY = "apt_admin_auth";
const TOKEN_KEY = "apt_admin_token";  // ✅ key to store the token

// ✅ Restore token on page refresh — call this in main.jsx/App.jsx
export const restoreAuth = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
};

// check if admin is logged in
export const isAdmin = () => {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
};

// login using backend
export const loginAdmin = async (username, password) => {
  try {
    const res = await loginRequest(username, password);

    if (res.data.success && res.data.role === "admin") {
      localStorage.setItem(KEY, "1");
      localStorage.setItem(TOKEN_KEY, res.data.token);  // ✅ save token

      // ✅ attach token to all future axios requests
      axios.defaults.headers.common["Authorization"] = `Bearer ${res.data.token}`;

      window.dispatchEvent(
        new StorageEvent("storage", { key: KEY, newValue: "1" })
      );
      return { success: true, message: res.data.message };
    } else {
      return { success: false, message: res.data.message || "Login failed" };
    }
  } catch (err) {
    console.error("Login error:", err.response?.data || err);
    return {
      success: false,
      message: err.response?.data?.message || "Erreur serveur",
    };
  }
};

// logout
export const logoutAdmin = async () => {
  try {
    await axios.post("https://api.allianceprotravaux.be/api/logout"); // ✅ delete token on backend
  } catch (_) {
    // ignore if token already expired
  } finally {
    localStorage.removeItem(KEY);
    localStorage.removeItem(TOKEN_KEY);  // ✅ remove token
    delete axios.defaults.headers.common["Authorization"];  // ✅ remove from axios

    window.dispatchEvent(
      new StorageEvent("storage", { key: KEY, newValue: null })
    );
  }
};